exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container-input[data-v-13f01bff]{margin-right:20px\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/assinatura/components/DadosDocumento.vue"],"names":[],"mappings":";AAmFA,kCACE,iBAAkB;CACnB","file":"DadosDocumento.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import \"@/assets/styles/element-variables.scss\";\n\n.container-input {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13f01bff","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/assinatura/components/DadosDocumento.vue
// module id = pMOj
// module chunks = 11